import axios from "axios";

const BACKOFFICE = process.env.REACT_APP_BACKOFFICE_URL;
const VERSION = process.env.REACT_APP_VERSION;

const apiClient = axios.create({
  baseURL: `${BACKOFFICE}/${VERSION}`,
  headers: {
    "Content-type": "application/json",
  },
});

export default apiClient;
